import { DetailProductData } from "src/data/product-details/types"
import { useIsClient } from "src/hooks/useIsClient"
import { createPersistentStore } from "src/utilities/localStorage/create"

type State = Record<number, number>

const defaultState: State = {}

const store = createPersistentStore(() => defaultState, {
  name: "selectedVariationByProductId",
})

export function setSelectedVariationByProductId(productId: number, variationId: number) {
  store.setState({ [productId]: variationId })
}

export function useSelectedVariationByProductId(product: DetailProductData, defaultVariationId: number | undefined) {
  const isClient = useIsClient()
  const value = store((state) => state[product.id])

  if (!isClient || !value || !product.variations?.some((variation) => variation.id === value)) {
    return defaultVariationId
  }

  return value
}
